import React from 'react';
import { RowButtonWrapper } from 'components/Layout/RowButton/styled';

const RowButton = ({ children }) => {
  return <RowButtonWrapper>{children}</RowButtonWrapper>;
};

export default RowButton;
